import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import * as PropTypes from 'prop-types';

import { Button } from '@lwt-helix/buttons';

import { fetchSecurityGroups } from '../../../../api/SecurityGroupApi';
import { fetchMembers } from '../../../../api/RosterApi';
import UsersModal from './UsersModal';
import { filterOptions, mapOptions } from '../UsersDirectoryFunctions';

const InviteNewUser = ({
    clientId,
    rosterMembers,
    permissions,
    securityGroupNames,
    error,
    response
}) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const toggleModalStatus = () => { setModalIsOpen(!modalIsOpen) };
    const [options, setOptions] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchSecurityGroups());
        dispatch(fetchMembers());
    }, []);

    useEffect(() => {
        const filteredOptions = rosterMembers?.filter(filterOptions);
        const mappedOptions = filteredOptions ? filteredOptions.map(mapOptions) : null;
        setOptions(mappedOptions);
    }, [rosterMembers, clientId]);

    const usersModal = modalIsOpen
        ? (
            <UsersModal
                show={modalIsOpen}
                closeModal={() => { toggleModalStatus() }}
                securityGroups={securityGroupNames}
                options={options}
                permissions={permissions}
                clientId={clientId}
                error={error}
                response={response}
            />
        )
        : null;

    return (
        <>
            <Button
                color={'primary'}
                onClick={toggleModalStatus}
                dataLwtId={'invite-new-user-button'}
            >
                INVITE NEW USER
            </Button>
            {usersModal}
        </>
    );
};

const mapStateToProps = state => ({
    clientId: state.authenticationReducer.user.orgId,
    rosterMembers: state.roster.members,
    permissions: state.authorizationReducer.permissions.permissions,
    securityGroupNames: state.securityGroup.securityGroups,
    error: state.authenticationReducer.createInvitesError,
    response: state.authenticationReducer.createInvitesResponse
});

InviteNewUser.propTypes = {
    clientId: PropTypes.string,
    rosterMembers: PropTypes.array,
    permissions: PropTypes.object,
    securityGroupNames: PropTypes.array,
    error: PropTypes.object,
    response: PropTypes.array
};

export default withRouter(connect(mapStateToProps)(InviteNewUser));